module.exports = __webpack_public_path__ + "img/1-10.7b53945c.png";